import {KTCard, KTCardBody} from "../../../../_websoft/helpers";
import {ToastContainer} from "react-toastify";
import React, {useState} from "react";
import {getRedomatAll} from "../../../api/redomat";
import {RedomatModel} from "../../../models/Redomat";

const Redomat: React.FC = () => {
    const [redomati, setRedomati] = useState<RedomatModel[]>([]);
    const [loading, setLoading] = useState(true);
    const fetchData = async () => {
        try {
            const res = await getRedomatAll();
            setRedomati(res.data);
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };
    fetchData();

return (
        <KTCard>
            <ToastContainer/>
            <KTCardBody className='py-4'>
                <div className='row'>
                    <div className='col-xl-4 mt-2'>
                        <div className='col mt-2'>
                            <a
                                href='redomat/pocetak'
                                className='card bg-success hoverable card-xl-stretch mb-xl-8'>
                                <div className='card-body'>
                                    <i className='ki-duotone ki-truck text-white fs-3x ms-n1'>
                                        <span className='path1'></span>
                                        <span className='path2'></span>
                                        <span className='path3'></span>
                                        <span className='path4'></span>
                                    </i>
                                    <div className='text-white fw-bold fs-2 mb-2 mt-5'>Utovar start</div>
                                </div>
                            </a>
                        </div>
                        <div className='col mt-2'>
                            <a
                                href='redomat/kraj'
                                className='card bg-danger hoverable card-xl-stretch mb-xl-8'
                            >
                                <div className='card-body'>
                                    <i className='ki-duotone ki-truck text-white fs-3x ms-n1'>
                                        <span className='path1'></span>
                                        <span className='path2'></span>
                                        <span className='path3'></span>
                                        <span className='path4'></span>
                                    </i>
                                    <div className='text-white fw-bold fs-2 mb-2 mt-5'>Utovar kraj</div>
                                </div>
                            </a>
                        </div>

                    </div>
                    <div className="col-xl-1"></div>
                    <div className="col-xl-5 mt-4 d-flex flex-wrap gap-3">
                        {redomati.map((item) => (
                            <div
                                key={item.Id}
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    backgroundColor: item.Status === "U" ? "green" : "red",
                                    color: "#fff",
                                    fontSize: "34px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "8px",
                                }}
                            >
                                {item.RedniBroj}
                            </div>
                        ))}
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    );
}
export default Redomat;